export default function Footer() {
  const handleScroll = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-background-100 border-t border-background-300/40">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-10">
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-2 mb-3">
              <span className="text-xl font-bold font-heading text-primary-500">6080</span>
              <span className="text-sm font-medium text-foreground-600">影院</span>
            </div>
            <p className="text-xs text-foreground-500 leading-relaxed">
              电影大全免费在线高清点播平台，最新电影、经典电影、动作电影、喜剧电影全覆盖，不缓冲播放随时畅享。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-800 mb-3">快速导航</h4>
            <div className="flex flex-col gap-2">
              {[
                { label: '最新上架', href: '#updates' },
                { label: '影片导览', href: '#index' },
                { label: '热播排行', href: '#ranking' },
                { label: '平台特色', href: '#features' },
              ].map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={(e) => handleScroll(e, link.href)}
                  className="text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-800 mb-3">影片分类</h4>
            <div className="flex flex-col gap-2">
              {['最新电影', '经典电影', '动作电影', '喜剧电影', '科幻电影', '悬疑电影'].map((cat) => (
                <a
                  key={cat}
                  href="#index"
                  onClick={(e) => handleScroll(e, '#index')}
                  className="text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap"
                >
                  {cat}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-800 mb-3">帮助信息</h4>
            <div className="flex flex-col gap-2">
              {[
                { label: '常见问题', href: '#faq' },
                { label: '意见反馈', href: '#contact' },
                { label: '关于我们', href: '#about' },
                { label: '手机观影', href: '#app' },
              ].map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={(e) => handleScroll(e, link.href)}
                  className="text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="border-t border-background-300/30 pt-6 mb-6">
          <h4 className="text-xs font-semibold text-foreground-600 mb-3">合作伙伴</h4>
          <p className="text-xs text-foreground-400">优质影视资源合作方持续招募中，欢迎联系洽谈。</p>
        </div>

        <div className="border-t border-background-300/30 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-400">
            &copy; 2026 6080影院 · 电影大全免费在线高清点播平台
          </p>
          <div className="flex items-center gap-4">
            <a
              href="#hero"
              onClick={(e) => handleScroll(e, '#hero')}
              className="text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer"
            >
              回到顶部 <i className="ri-arrow-up-line text-xs"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}